export function checkStringEmpty(input: string|null): boolean {
    return input === null || input === "";
}
